function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "e4h/group-assignment");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\uD83D\\uDDA5-Wireframes-Desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Artboard",
  transform: "translate(-2350.000000, -2103.000000)"
}, React.createElement("g", {
  id: "e4h/group-assignment",
  transform: "translate(2351.000000, 2103.000000)"
}, React.createElement("g", {
  id: "assignment",
  transform: "translate(10.000000, 0.000000)",
  fill: "#009BDF",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Rectangle"
}, React.createElement("g", {
  id: "Mask"
}, React.createElement("path", {
  d: "M31.4998291,0 C29.4856201,0 27.5859131,0.78544921 26.1493408,2.21347658 C24.7219971,3.64082033 23.9358643,5.54121099 23.9358643,7.56396487 L23.9358643,7.6890625 C20.4778626,7.92045898 17.4842346,9.85571286 15.7719605,12.6560547 L4.25964357,12.6560547 C2.16955571,12.6560547 0.4691162,14.3561523 0.4691162,16.446582 C0.4691162,46.9341966 0.4691162,69.7999076 0.4691162,85.0437149 C0.4691162,85.6911224 62.5308838,85.6879722 62.5308838,85.0389895 C62.5308838,69.7962323 62.5308838,46.9320965 62.5308838,16.446582 C62.5308838,14.3561524 60.8304444,12.6560547 58.7403564,12.6560547 L47.2277832,12.6560547 C45.5155945,9.85571286 42.5221374,7.92045898 39.0641357,7.6890625 L39.0641357,7.56396487 C39.0641357,3.39335941 35.6707764,0 31.4998291,0 Z M58.7403564,14.0560547 C60.058667,14.0560547 61.1308838,15.1286133 61.1308838,16.446582 C61.1308838,47.4030785 61.1308838,70.6204508 61.1308838,86.098699 C61.1308838,86.3944452 1.8691162,86.5244263 1.8691162,86.2936707 C1.8691162,70.7720955 1.8691162,47.4897326 1.8691162,16.446582 C1.8691162,15.1286133 2.94133301,14.0560547 4.25964357,14.0560547 L15.0523926,14.0560547 C14.5361084,15.2884033 14.2462647,16.6381592 14.2462647,18.0557617 L14.2462647,18.725 C14.2462647,19.1119141 14.5596924,19.425 14.9462647,19.425 L48.0533936,19.425 C48.4399658,19.425 48.7533936,19.1119141 48.7533936,18.725 L48.7533936,18.0557617 C48.7533936,16.6381592 48.4635498,15.2884033 47.9473084,14.0560547 L58.7403564,14.0560547 Z M47.3533936,18.025 L15.6462646,18.025 C15.6630127,13.0819336 19.6893799,9.06582033 24.6358643,9.06582033 C25.0224365,9.06582033 25.3358643,8.75273441 25.3358643,8.36582033 L25.3358643,7.56396487 C25.3358643,5.91513671 25.9763916,4.36611329 27.1378174,3.2046875 C28.3088135,2.04121092 29.8578369,1.4 31.4998291,1.4 C34.898999,1.4 37.6641357,4.16513671 37.6641357,7.56396487 L37.6641357,8.36582033 C37.6641357,8.75273441 37.9775635,9.06582033 38.3641357,9.06582033 C43.3106202,9.06582033 47.3366455,13.0819336 47.3533936,18.025 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M31.4998291,3.85410158 C29.7614502,3.85410158 28.3474365,5.26845704 28.3474365,7.00683599 C28.3474365,8.74521494 29.7614502,10.1588868 31.4998291,10.1588868 C33.2382081,10.1588868 34.6522217,8.74521487 34.6522217,7.00683599 C34.6522217,5.26845711 33.238208,3.85410158 31.4998291,3.85410158 Z M31.4998291,8.75888671 C30.5335694,8.75888671 29.7474365,7.97275388 29.7474365,7.00683592 C29.7474365,6.04023434 30.5335694,5.25410151 31.4998291,5.25410151 C32.4660889,5.25410151 33.2522217,6.04023434 33.2522217,7.00683592 C33.2522217,7.97275388 32.4660889,8.75888671 31.4998291,8.75888671 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M19.7310791,25.2166992 L6.86857913,25.2166992 C6.48200686,25.2166992 6.16857913,25.5297851 6.16857913,25.9166992 L6.16857913,38.7791992 C6.16857913,39.1661133 6.48200686,39.4791992 6.86857913,39.4791992 L19.7310791,39.4791992 C20.1176514,39.4791992 20.4310791,39.1661133 20.4310791,38.7791992 L20.4310791,25.9166992 C20.4310791,25.5297851 20.1176514,25.2166992 19.7310791,25.2166992 Z M19.0310791,38.0791992 L7.56857913,38.0791992 L7.56857913,26.6166992 L19.0310791,26.6166992 L19.0310791,38.0791992 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M23.7560791,28.9354492 C23.7560791,29.3223633 24.0695069,29.6354492 24.4560791,29.6354492 L56.1310791,29.6354492 C56.5176514,29.6354492 56.8310791,29.3223633 56.8310791,28.9354492 C56.8310791,28.5485351 56.5176514,28.2354492 56.1310791,28.2354492 L24.4560791,28.2354492 C24.0695069,28.2354492 23.7560791,28.5485351 23.7560791,28.9354492 Z",
  id: "Path"
}), React.createElement("path", {
  d: "M24.4560791,36.4604492 L46.9435791,36.4604492 C47.3301514,36.4604492 47.6435791,36.1473633 47.6435791,35.7604492 C47.6435791,35.3735351 47.3301514,35.0604492 46.9435791,35.0604492 L24.4560791,35.0604492 C24.0695069,35.0604492 23.7560791,35.3735351 23.7560791,35.7604492 C23.7560791,36.1473633 24.0695069,36.4604492 24.4560791,36.4604492 Z",
  id: "Path"
})))), React.createElement("g", {
  id: "Group-2",
  transform: "translate(0.000000, 41.500000)",
  fill: "#FFFFFF",
  stroke: "#009BDF",
  strokeWidth: 1.5
}, React.createElement("circle", {
  id: "Oval-Copy",
  cx: 16,
  cy: 14,
  r: 9
}), React.createElement("circle", {
  id: "Oval-Copy-3",
  cx: 42,
  cy: 12,
  r: 12
}), React.createElement("circle", {
  id: "Oval-Copy-2",
  cx: 65.75,
  cy: 14,
  r: 9
}), React.createElement("path", {
  d: "M8,26 L24,26 C28.418278,26 32,29.581722 32,34 L32,44 L32,44 L0,44 L0,34 C-5.41083001e-16,29.581722 3.581722,26 8,26 Z",
  id: "Rectangle-Copy"
}), React.createElement("path", {
  d: "M59,26 L75,26 C79.418278,26 83,29.581722 83,34 L83,44 L83,44 L51,44 L51,34 C51,29.581722 54.581722,26 59,26 Z",
  id: "Rectangle-Copy-2"
}), React.createElement("path", {
  d: "M31,27 L52,27 C56.418278,27 60,30.581722 60,35 L60,48 L60,48 L23,48 L23,35 C23,30.581722 26.581722,27 31,27 Z",
  id: "Rectangle"
})))));

var SvgGroupassignment = function SvgGroupassignment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "80px",
    height: "91px",
    viewBox: "0 0 85 91",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGroupassignment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/group assignment.2d8a1131.svg";
export { ForwardRef as ReactComponent };